<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

export interface StoryblokHeroProps {
    blok: StoryblokHero;
}

// PROPS
const { blok } = defineProps<StoryblokHeroProps>();

// COMPOSABLES
const { classes } = useStoryblokComponentClass(() => lodashPick(blok, ['anchorId']));
</script>

<template>
    <section :id="blok.anchorId" v-editable="blok" class="space-y-14 py-12 lg:space-y-12" :class="classes">
        <BaseWidthContainer v-if="!!blok.title" as="h1" class="text-primary-800 text-center text-4xl font-semibold sm:text-5xl">
            {{ blok.title }}<template v-if="!!blok.subtitle"><br />{{ blok.subtitle }}</template>
        </BaseWidthContainer>

        <div v-if="blok.media && blok.media.length" class="flex flex-row flex-nowrap gap-2">
            <StoryblokComponent v-for="m in blok.media" :key="m._uid" :blok="m" />
        </div>

        <BaseWidthContainer class="flex flex-col items-center gap-y-14 lg:gap-y-12">
            <StoryblokRichTextOverride v-if="!!blok.description" class="max-w-5xl text-base" :doc="blok.description" />
            <div v-if="blok.body && blok.body.length" class="flex flex-row flex-nowrap gap-2">
                <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
            </div>
        </BaseWidthContainer>
    </section>
</template>
